import React from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Chip,
    Divider,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Constants from "../../../../utils/constants.js";
import {dashboardHelper} from "../utils/dashboardHelper";
import HeureDebutChip from "./HeureDebutChip.js";

const DashboardMapSidePanel = ({mode, clientsData, selectedTournee, onTourneeClick}) => {
    if (!clientsData) return null;

    return (
        <Stack sx={{height: "calc(100vh - 128px - 3rem)", width: "100%"}}>
            <Paper sx={{height: "100%", p: 2, overflowY: 'auto'}}>
                {mode === 'exploitant' &&
                    Object.entries(clientsData).map(([clientName, clientData]) => (
                        <Accordion key={clientName} defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{width: '100%'}}
                                >
                                    <Typography variant="h6" sx={{fontWeight: 'bold'}}>{clientName}</Typography>
                                    <Stack direction="row" spacing={1}>
                                        <Chip
                                            label={`${clientData.totalBacsLaves} / ${clientData.totalALaver}`}
                                            size="small"
                                            sx={{backgroundColor: Constants.COLOR_THEME_GREEN, color: "white"}}
                                        />
                                        {clientData.totalBacsImpossible > 0 &&
                                            <Chip
                                                label={`${clientData.totalBacsImpossible}`}
                                                size="small"
                                                sx={{backgroundColor: Constants.COLOR_THEME_RED, color: "white"}}
                                            />
                                        }
                                    </Stack>
                                </Stack>
                            </AccordionSummary>

                            <AccordionDetails>
                                {Object.entries(clientData.operateurs).map(([equipeName, equipeData]) => (
                                    <Accordion key={equipeName} disableGutters square sx={{mb: 1}} defaultExpanded>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                backgroundColor: '#f9f9f9',
                                                borderLeft: `4px solid ${dashboardHelper.getColorByEquipe(equipeName)}`,
                                                px: 1
                                            }}
                                        >
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                justifyContent="space-between"
                                                sx={{width: '100%'}}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{color: dashboardHelper.getColorByEquipe(equipeName)}}
                                                >
                                                    {equipeName}
                                                </Typography>

                                                <Stack direction="row" spacing={1}>
                                                    <Chip
                                                        label={`${equipeData.totalBacsLaves} / ${equipeData.totalALaver}`}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: Constants.COLOR_THEME_GREEN,
                                                            color: "white"
                                                        }}
                                                    />
                                                    {equipeData.totalBacsImpossible > 0 &&
                                                        <Chip
                                                            label={`${equipeData.totalBacsImpossible}`}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: Constants.COLOR_THEME_RED,
                                                                color: "white"
                                                            }}
                                                        />
                                                    }
                                                </Stack>
                                            </Stack>
                                        </AccordionSummary>

                                        <AccordionDetails>
                                            <Stack spacing={1}>
                                                {equipeData.tours.map(tournee => (
                                                    <Box
                                                        key={tournee.id}
                                                        onClick={() => onTourneeClick(tournee)}
                                                        sx={{
                                                            p: 1,
                                                            borderRadius: 1,
                                                            cursor: 'pointer',
                                                            backgroundColor: selectedTournee?.id === tournee.id
                                                                ? dashboardHelper.getColorByEquipe(equipeName)
                                                                : '#f7f7f7',
                                                            color: selectedTournee?.id === tournee.id ? 'white' : 'black'
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{fontWeight: 'bold'}}>
                                                            {tournee.libelle}
                                                        </Typography>
                                                        <Stack direction="row" spacing={1} sx={{mt: 0.5}}>
                                                            <HeureDebutChip heureDebut={tournee.heureDebut}
                                                                            sx={{color: 'inherit', borderColor: 'currentColor', '& .MuiChip-icon': {color: 'inherit'}}}/>
                                                            <Chip
                                                                label={`${tournee.totalBacsLaves} / ${tournee.totalALaver}`}
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor: Constants.COLOR_THEME_GREEN,
                                                                    color: "white"
                                                                }}
                                                            />
                                                            {tournee.totalBacsImpossible > 0 &&
                                                                <Chip
                                                                    label={`${tournee.totalBacsImpossible}`}
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor: Constants.COLOR_THEME_RED,
                                                                        color: "white"
                                                                    }}
                                                                />
                                                            }
                                                        </Stack>
                                                    </Box>
                                                ))}
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                                <Divider sx={{mt: 2}} />
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </Paper>
        </Stack>
    );
};

export default DashboardMapSidePanel;
